import { UserData } from 'pages/offer/types';
import { formatDate, formatPhoneNumber } from 'shared/lib';

/**
 * Transform backend data format to frontend data format
 * @param data
 */
export const TransformBackDataToFrontData = (data: UserData): UserData => {
  const { actionEnds, paidAnnualLeave } = data;
  const formattedContractEndDate = formatDate(actionEnds);
  const formattedPhone = formatPhoneNumber(data.recruiterTelephone);
  const [curPaidAnnualLeave] = paidAnnualLeave ? paidAnnualLeave.split(' ') : '';

  return {
    ...data,
    actionEnds: formattedContractEndDate,
    paidAnnualLeave: curPaidAnnualLeave,
    recruiterTelephone: formattedPhone,
  };
};
